import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import messages from '@app/components/common/AddressDisplay.vue

Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: 'ja',
  fallbackLocale: 'ja',
  messages: {
    ja: require('~/locales/ja.json'),
    // en: require('~/locales/en.json'),
  },
})

export default ({ app }: { app: any }) => {
  // Set i18n instance on app
  // This way we can use it in middleware and pages asyncData/fetch
  app.i18n = i18n
}
